// AUTH types
export const AUTH_USER_SET = "AUTH_USER_SET";
export const AUTH_TOKEN_SET = "AUTH_TOKEN_SET";
